'use client'

import PropTypes from 'prop-types'
import { Modal } from '@repo/ui/Modal'
import MUITypography from '@mui/material/Typography'
import MUIButton from '@mui/material/Button'
import MUIStack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'

export const AlertDialog = ({ show, proceed, confirmation }) => {
  const theme = useTheme()
  const { isOutlookAddin } = useGlobalSettingsStore()

  return (
    <div data-testid="AlertDialog">
      <Modal
        open={show}
        handleClose={() => proceed(false)}
        title="Alert"
        sx={{ maxWidth: isOutlookAddin ? '300px' : '460px' }}
      >
        <hr
          style={{
            opacity: 0.12,
            borderColor: theme?.palette?.support?.navy || 'black',
            borderTop: 'none',
            marginBottom: '24px'
          }}
        />

        {typeof confirmation === 'string' ? (
          <MUITypography variant="body1" sx={{ mt: 6, mb: 10 }}>
            {confirmation}
          </MUITypography>
        ) : (
          <MUIStack sx={{ mt: 0, mb: 10 }}>{confirmation}</MUIStack>
        )}

        <MUIStack direction="row" alignItems="center" justifyContent="flex-end" gap={2} sx={{ mt: 6 }}>
          <MUIButton variant="contained" onClick={() => proceed(false)}>
            OK
          </MUIButton>
        </MUIStack>
      </Modal>
    </div>
  )
}

AlertDialog.propTypes = {
  show: PropTypes.bool, // from confirmable. indicates if the dialog is shown or not.
  proceed: PropTypes.func, // from confirmable. call to close the dialog with promise resolved.
  confirmation: PropTypes.string, // arguments of your confirm function
  options: PropTypes.object // arguments of your confirm function
}
